import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RealTimeCaptionsComponent } from '@go-modules/components/real-time-captions/real-time-captions.component';
import { RealTimeCaptionsService } from 'go-modules/captions/real-time-captions.service';

@NgModule({
	declarations: [RealTimeCaptionsComponent],
	imports: [CommonModule],
	exports: [RealTimeCaptionsComponent],
	providers: [RealTimeCaptionsService]
})

export class RealTimeCaptionsModule {}
